
import { useState } from 'react';

interface BeforeAfterCase {
  id: number;
  title: string;
  location: string;
  serviceType: string;
  beforeImage: string;
  afterImage: string;
  description: string;
  highlights: string[];
}

const BeforeAfterSection = () => {
  const [activeCase, setActiveCase] = useState<number | null>(null);
  const [sliderPositions, setSliderPositions] = useState<{ [key: number]: number }>({});

  const beforeAfterCases: BeforeAfterCase[] = [
    {
      id: 1,
      title: '客廳空間整理搬遷',
      location: '新北市板橋區',
      serviceType: '家庭搬遷',
      beforeImage: 'https://public.readdy.ai/ai/img_res/d8fe67922b8e87ea8e45a8c14e425bdc.jpg',
      afterImage: 'https://readdy.ai/api/search-image?query=Clean%20organized%20Taiwan%20apartment%20living%20room%20after%20professional%20moving%20service%2C%20neatly%20arranged%20furniture%2C%20tidy%20space%2C%20all%20items%20properly%20placed%2C%20fresh%20and%20clean%20atmosphere%2C%20professional%20moving%20result%2C%20natural%20lighting&width=600&height=400&seq=after-living-1&orientation=landscape',
      description: '從雜亂的搬家準備到整齊有序的新居，建鈞搬家團隊協助客戶完成完美的空間轉換',
      highlights: ['家具定位擺放', '物品分類整理', '空間規劃建議']
    },
    {
      id: 2,
      title: '臥室家具搬運整理',
      location: '台北市信義區',
      serviceType: '精緻搬家',
      beforeImage: 'https://readdy.ai/api/search-image?query=Taiwan%20bedroom%20before%20moving%20with%20mattress%20wrapped%20in%20protective%20material%2C%20furniture%20covered%20with%20moving%20blankets%2C%20boxes%20stacked%2C%20preparation%20for%20relocation%2C%20realistic%20indoor%20scene&width=600&height=400&seq=before-bedroom-2&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Beautiful%20organized%20Taiwan%20bedroom%20after%20professional%20moving%2C%20bed%20perfectly%20made%20with%20clean%20bedding%2C%20furniture%20neatly%20arranged%2C%20wardrobe%20organized%2C%20peaceful%20and%20tidy%20atmosphere%2C%20professional%20result&width=600&height=400&seq=after-bedroom-2&orientation=landscape',
      description: '專業的床墊防護與家具搬運，確保臥室物品完好無損地安置到新家',
      highlights: ['床墊專業防護', '衣櫃拆裝服務', '寢具整理歸位']
    },
    {
      id: 3,
      title: '廚房設備搬遷',
      location: '桃園市中壢區',
      serviceType: '家庭搬遷',
      beforeImage: 'https://readdy.ai/api/search-image?query=Taiwan%20kitchen%20before%20moving%20with%20appliances%20wrapped%2C%20dishes%20packed%20in%20boxes%2C%20refrigerator%20covered%20with%20protective%20wrap%2C%20moving%20preparation%20chaos%2C%20realistic%20kitchen%20scene&width=600&height=400&seq=before-kitchen-3&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Clean%20modern%20Taiwan%20kitchen%20after%20professional%20moving%20service%2C%20appliances%20properly%20installed%2C%20dishes%20organized%20in%20cabinets%2C%20refrigerator%20in%20place%2C%20everything%20neat%20and%20functional%2C%20bright%20and%20clean%20atmosphere&width=600&height=400&seq=after-kitchen-3&orientation=landscape',
      description: '廚房電器與餐具的專業包裝搬運，搬到新家後立即可以使用',
      highlights: ['冰箱安全搬運', '餐具防護包裝', '電器定位安裝']
    },
    {
      id: 4,
      title: '辦公室整體搬遷',
      location: '新北市中和區',
      serviceType: '辦公室搬遷',
      beforeImage: 'https://readdy.ai/api/search-image?query=Taiwan%20office%20before%20moving%20with%20desks%20covered%2C%20computers%20packed%20in%20boxes%2C%20chairs%20stacked%2C%20documents%20in%20moving%20boxes%2C%20office%20relocation%20preparation%2C%20realistic%20commercial%20space&width=600&height=400&seq=before-office-4&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Modern%20organized%20Taiwan%20office%20after%20professional%20moving%2C%20desks%20properly%20arranged%2C%20computers%20set%20up%20and%20ready%2C%20ergonomic%20chairs%20in%20place%2C%20clean%20professional%20workspace%2C%20ready%20for%20business&width=600&height=400&seq=after-office-4&orientation=landscape',
      description: '辦公室搬遷不影響營運，快速完成設備安裝與空間配置',
      highlights: ['電腦設備保護', '文件分類搬運', '辦公桌椅定位']
    },
    {
      id: 5,
      title: '書房收納搬遷',
      location: '新竹市東區',
      serviceType: '精緻搬家',
      beforeImage: 'https://readdy.ai/api/search-image?query=Taiwan%20study%20room%20before%20moving%20with%20books%20packed%20in%20boxes%2C%20bookshelf%20disassembled%2C%20desk%20covered%2C%20papers%20and%20documents%20in%20moving%20boxes%2C%20cluttered%20preparation%20scene&width=600&height=400&seq=before-study-5&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Organized%20Taiwan%20study%20room%20after%20professional%20moving%2C%20bookshelf%20assembled%20with%20books%20neatly%20arranged%2C%20desk%20set%20up%20with%20computer%2C%20comfortable%20reading%20corner%2C%20peaceful%20study%20atmosphere&width=600&height=400&seq=after-study-5&orientation=landscape',
      description: '書籍與文件的細心分類搬運，書房空間完美重現',
      highlights: ['書籍分類打包', '書櫃拆裝組合', '文件整理歸檔']
    },
    {
      id: 6,
      title: '兒童房搬遷佈置',
      location: '台北市大安區',
      serviceType: '家庭搬遷',
      beforeImage: 'https://readdy.ai/api/search-image?query=Taiwan%20children%20room%20before%20moving%20with%20toys%20packed%2C%20bed%20disassembled%2C%20colorful%20items%20in%20boxes%2C%20kids%20furniture%20wrapped%2C%20moving%20preparation%20for%20family%20relocation&width=600&height=400&seq=before-kids-6&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Cheerful%20organized%20Taiwan%20children%20room%20after%20moving%2C%20colorful%20bed%20set%20up%2C%20toys%20neatly%20arranged%20on%20shelves%2C%20study%20desk%20ready%2C%20bright%20and%20happy%20kids%20space%2C%20safe%20and%20comfortable%20atmosphere&width=600&height=400&seq=after-kids-6&orientation=landscape',
      description: '兒童房物品的安全搬運與溫馨佈置，讓孩子快速適應新環境',
      highlights: ['玩具安全包裝', '兒童床組裝', '學習區規劃']
    },
    {
      id: 7,
      title: '倉庫清運整理',
      location: '新北市新莊區',
      serviceType: '廢棄物清運',
      beforeImage: 'https://readdy.ai/api/search-image?query=Cluttered%20Taiwan%20storage%20room%20before%20cleanup%2C%20old%20furniture%20piled%20up%2C%20junk%20and%20unused%20items%20everywhere%2C%20dusty%20and%20messy%20warehouse%20space%2C%20needs%20professional%20clearing&width=600&height=400&seq=before-storage-7&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Clean%20empty%20Taiwan%20storage%20room%20after%20professional%20junk%20removal%2C%20spotless%20floor%2C%20organized%20shelving%2C%20bright%20and%20spacious%20warehouse%2C%20ready%20for%20new%20use%2C%20professional%20cleanup%20result&width=600&height=400&seq=after-storage-7&orientation=landscape',
      description: '舊物清運與空間整理，讓閒置空間煥然一新',
      highlights: ['舊家具清運', '環保回收處理', '空間清潔整理']
    },
    {
      id: 8,
      title: '陽台空間整理',
      location: '台北市松山區',
      serviceType: '家庭搬遷',
      beforeImage: 'https://readdy.ai/api/search-image?query=Taiwan%20apartment%20balcony%20before%20moving%20with%20plants%20in%20boxes%2C%20outdoor%20furniture%20wrapped%2C%20cleaning%20supplies%20packed%2C%20cluttered%20balcony%20space%20during%20relocation&width=600&height=400&seq=before-balcony-8&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Beautiful%20organized%20Taiwan%20apartment%20balcony%20after%20moving%2C%20plants%20arranged%20nicely%2C%20outdoor%20furniture%20set%20up%2C%20cozy%20relaxation%20space%2C%20clean%20and%20inviting%20atmosphere%2C%20city%20view&width=600&height=400&seq=after-balcony-8&orientation=landscape',
      description: '陽台植栽與戶外家具的細心搬運，打造舒適休憩空間',
      highlights: ['植栽安全搬運', '戶外家具定位', '空間美化建議']
    }
  ];

  const handleSliderMove = (caseId: number, e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
    const container = e.currentTarget;
    const rect = container.getBoundingClientRect();
    let clientX: number;
    
    if ('touches' in e) {
      clientX = e.touches[0].clientX;
    } else {
      clientX = e.clientX;
    }
    
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    
    setSliderPositions(prev => ({
      ...prev,
      [caseId]: percentage
    }));
  };

  const getSliderPosition = (caseId: number) => {
    return sliderPositions[caseId] ?? 50;
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題區域 */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-100 to-emerald-100 border border-teal-300 rounded-full px-5 py-2 shadow-sm mb-6">
            <i className="ri-contrast-2-line text-teal-600 text-lg"></i>
            <span className="text-sm font-bold text-teal-700">搬家前後對比</span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <strong>客戶搬家前後對比照片</strong>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-4">
            拖曳滑桿查看搬家前後的驚人變化，見證<strong className="text-teal-600">建鈞搬家</strong>的專業服務成果
          </p>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">
            <i className="ri-hand-coin-line mr-2"></i>
            左右拖曳滑桿，對比搬家前後的空間變化
          </p>
        </div>

        {/* 對比照片網格 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {beforeAfterCases.map((caseItem) => (
            <div
              key={caseItem.id}
              className="bg-white rounded-3xl shadow-xl overflow-hidden group hover:shadow-2xl transition-all duration-300"
            >
              {/* 對比滑桿區域 */}
              <div
                className="relative h-72 md:h-80 cursor-ew-resize overflow-hidden"
                onMouseMove={(e) => handleSliderMove(caseItem.id, e)}
                onTouchMove={(e) => handleSliderMove(caseItem.id, e)}
                onMouseEnter={() => setActiveCase(caseItem.id)}
                onMouseLeave={() => setActiveCase(null)}
              >
                {/* After 圖片（底層） */}
                <div className="absolute inset-0">
                  <img
                    src={caseItem.afterImage}
                    alt={`${caseItem.title} - 搬家後`}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 right-4 bg-emerald-600 text-white px-3 py-1.5 rounded-full text-sm font-semibold shadow-lg">
                    <i className="ri-check-line mr-1"></i>搬家後
                  </div>
                </div>

                {/* Before 圖片（上層，可裁切） */}
                <div
                  className="absolute inset-0 overflow-hidden"
                  style={{ width: `${getSliderPosition(caseItem.id)}%` }}
                >
                  <img
                    src={caseItem.beforeImage}
                    alt={`${caseItem.title} - 搬家前`}
                    className="w-full h-full object-cover object-top"
                    style={{ 
                      width: `${100 / (getSliderPosition(caseItem.id) / 100)}%`,
                      maxWidth: 'none'
                    }}
                  />
                  <div className="absolute top-4 left-4 bg-gray-700 text-white px-3 py-1.5 rounded-full text-sm font-semibold shadow-lg">
                    <i className="ri-time-line mr-1"></i>搬家前
                  </div>
                </div>

                {/* 滑桿線條 */}
                <div
                  className="absolute top-0 bottom-0 w-1 bg-white shadow-xl z-10"
                  style={{ left: `${getSliderPosition(caseItem.id)}%`, transform: 'translateX(-50%)' }}
                >
                  {/* 滑桿手把 */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center border-4 border-teal-500">
                    <i className="ri-arrow-left-right-line text-teal-600 text-xl"></i>
                  </div>
                </div>

                {/* 提示文字 */}
                {activeCase !== caseItem.id && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    <div className="bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg">
                      <span className="text-gray-700 font-medium text-sm">
                        <i className="ri-drag-move-2-line mr-2"></i>拖曳滑桿查看對比
                      </span>
                    </div>
                  </div>
                )}
              </div>

              {/* 案例資訊 */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-xl font-bold text-gray-900">{caseItem.title}</h3>
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm font-semibold">
                    {caseItem.serviceType}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-500 mb-4">
                  <i className="ri-map-pin-line text-teal-600"></i>
                  <span className="text-sm">{caseItem.location}</span>
                </div>

                <p className="text-gray-600 mb-4 leading-relaxed">{caseItem.description}</p>

                {/* 服務亮點 */}
                <div className="flex flex-wrap gap-2">
                  {caseItem.highlights.map((highlight, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center gap-1 bg-gradient-to-r from-teal-50 to-emerald-50 text-teal-700 px-3 py-1.5 rounded-full text-sm border border-teal-100"
                    >
                      <i className="ri-checkbox-circle-fill text-teal-500"></i>
                      {highlight}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 服務特色說明 */}
        <div className="bg-gradient-to-br from-teal-600 to-emerald-600 rounded-3xl p-8 md:p-12 text-white">
          <div className="text-center mb-10">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">為什麼選擇建鈞搬家？</h3>
            <p className="text-teal-100 text-lg">專業團隊 + 細心服務 = 完美搬家體驗</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl"></i>
              </div>
              <h4 className="font-bold text-lg mb-2">全程防護包裝</h4>
              <p className="text-teal-100 text-sm">專業防護材料，確保物品零損傷</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-3xl"></i>
              </div>
              <h4 className="font-bold text-lg mb-2">專業搬運團隊</h4>
              <p className="text-teal-100 text-sm">經驗豐富，動作迅速又細心</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-layout-grid-line text-3xl"></i>
              </div>
              <h4 className="font-bold text-lg mb-2">空間規劃建議</h4>
              <p className="text-teal-100 text-sm">協助家具定位，打造理想空間</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-sparkling-line text-3xl"></i>
              </div>
              <h4 className="font-bold text-lg mb-2">整理歸位服務</h4>
              <p className="text-teal-100 text-sm">搬完即可入住，省時又省力</p>
            </div>
          </div>
        </div>

        {/* 底部 CTA */}
        <div className="mt-12 text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">想要同樣的搬家體驗？</h3>
            <p className="text-gray-600 mb-6">立即聯絡我們，免費估價，讓您的搬家輕鬆又安心</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:0978900081"
                className="inline-flex items-center justify-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:scale-105"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>立即來電：0978-900-081</span>
              </a>
              <a
                href="https://line.me/ti/p/@285yavdh"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#06C755] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#05b34c] transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:scale-105"
              >
                <i className="ri-line-fill text-xl"></i>
                <span>LINE 免費諮詢</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
